<template>
  <div style="padding: 20px">
    <!-- <h1 style="text-align: center"><strong>开始赚会员推荐客户须知</strong></h1>
    <p style="text-align: left">
      一、本人自愿注册为&ldquo;开始赚&rdquo;平台会员，并同意连守本须知相关约定。<br />二、本人已知悉购房客户须在首次到访楼盘前，己在平台上被推荐，方可按照会员等级享受推荐成交佣金（佣金政策以平台公示为准）。<br />三、本人已知悉下述规则，并遵循操作：<br />&nbsp;
      &nbsp; &nbsp; 1.
      会员注册认证时，须确保本人姓名、身份证号、手机号码、银行卡号等个人信息真实准确，每人仅限注册认证唯一账号。<br />&nbsp;
      &nbsp; &nbsp; 2.
      会员保证所填写的被推荐客户信息（姓名、手机号码、身份证后六位）真实、准确、完整。
      <br />&nbsp; &nbsp; &nbsp;&nbsp;3.
      被推荐客户交齐首期款并签署《商品房买卖合同》，即为成功签约。在客户签约前，会员可选择将全部或部分佣金转为客户额外折扣优惠，平台最终计发给会员的佣金将扣除前述已转让&nbsp;
      &nbsp;
      &nbsp;&nbsp;部分，成功签约后15个工作日，平台将佣金支付至会员绑定的银行账户。<br />&nbsp;
      &nbsp; &nbsp;&nbsp;4.
      会员实得佣金已由平台按税法规定预缴税款，会员应于次年办理汇算清缴，并将佣金收入计入年度综合所得进行个人年度申报。如产生汇缴税率差异平台不再予以调整。<br />四、本人自愿兼职为无锡风水隆公司推荐客户，与无锡风水隆公司及其属下公司之间不存在劳动关系。<br />五、如因会员向平台故意提供虚假、错误信息，平台有权取消会员资格；如给平台造成不利影响或损失，平台将依法追诉。<br />&nbsp;
      &nbsp; &nbsp; 本人已阅读并同意上述《开始赚会员推荐客户须知》。
    </p>
    <h1 style="text-align: center"><br />开始赚隐私保护政策</h1>
    <p style="text-align: left">
      <br />&nbsp; &nbsp; &nbsp; 发布日期：2021年4月20日。<br />&nbsp; &nbsp;
      &nbsp;&nbsp;开始赚（以下称&ldquo;我们&rdquo;）尊重并保护用户（以下称&ldquo;您&rdquo;）的隐私和个人信息。您使用我们的产品及服务时，我们将按照《开始赚隐私保护政策》（以下称&ldquo;本政策&rdquo;）收集、存储、使用及对外提供您的个人信息。我们希望通过本政策向您说明在您使用我们的服务时，我们对个人信息收集的范围、对个人信息如何保存、使用、保护等，以及我们为您提供的访问、更新、删除和保护这些信息的方式。我们将按照法律法规要求，遵循业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。<br />本政策适用于我们向您提供的开始赚APP、小程序等产品和服务，但不适用于开始赚APP小程序中由第三方向您提供的产品或服务，也不适用于我们已另行设置独立隐私政策的产品或服务。<br />&nbsp;
      &nbsp; &nbsp;&nbsp;1）
      个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。如姓名、出生日期、身份证件号码、个人生物识别信息、住址、通信通讯联系方式、通信记录和内容、账号密码、财产信息、征信信息、行踪轨迹、住宿信息、健康生理信息、交易信息等。您保证您提供的个人信息是真实、合法、完整、有效的信息。<br />&nbsp;
      &nbsp; &nbsp; 2）
      我们将逐一说明我们收集的您的个人信息类型及其对应的用途，以便您了解我们针对某一特定功能所收集的具体个人信息的类别、使用理由及收集方式。<br />&nbsp;
      &nbsp; &nbsp;&nbsp;3）
      当您使用一些功能时，我们会在获存您的同意后，收集您的一些敏感信息，例如您在使用从通讯录获取推徐客户信息的功能时，我们会收族到您所选手机号：您在使用推荐客户功能。填写客户信息时，我们会收集到您推养客户的姓名，手机号、身份证号后六位等信息。除非按照相关法律法规要求必须收集，拒绝提供这些信息仅会使您无法使用相关特定功能。但不影响您正常使用开始赚的其他功能。<br />&nbsp;
      &nbsp; &nbsp;&nbsp;4）
      目前，开始赚一些功能会向相关监管机构授权的第三方提供信息用于信息真实性验证或服务提供。对此您予以充分理解并完全同意。如当您使用到某些功能触发开始赚短信发送时，为使您能成功收到相关短信，我们会将您的手机号共享至第三方短信运营商：当您使用身份证扫描功能上传证件照时，为验证您上传证件的有效性，我们会将身份证信息共享至第三方进行验证：当您使用认证功能或修改个人信息时，为验证您所填个人信息的正确性，我们会将您的姓名、手机号、身份证和银行卡号共享至第三方进行校验。我们会对对外提供信息的行为进行风险评估，确认以上第三方机构提供的验证服务合法合规。<br />&nbsp;
      &nbsp; &nbsp;&nbsp;5）
      目前，开始赚不会主动从无锡风水隆公司外的第三方获取您的个人信息。如未来为业务发展需要从第三方间接获取您的个人信息，我们会在获取前向您明示您个人信息的来源、类型及使用范围，如开始赚开展业务需进行的个人信息处理活动超出您原本向第三方提供个人信息时的授权同意范围，我们将在处理您的该等个人信息前，向您明示并征得您的同意；此外，我们会严格遵守相关法律法规的规定，不从非法渠道间接获取您的个人信息。<br />&nbsp;
      &nbsp; &nbsp;&nbsp;6）
      您可以通过本指引所列途径访问、更正、删除您的个人信息，也可以撤回同意、注销帐号、投诉举报以及设置隐私功能。<br />&nbsp;
      &nbsp;
      &nbsp;&nbsp;如您想了解更加详尽的信息，请根据以下索引阅读相应章节：<br />&nbsp;
      &nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;1. 我们收集的信息；<br />&nbsp;
      &nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;2. 信息的存储；<br />&nbsp;
      &nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;3. 信息安全；<br />&nbsp;
      &nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;4. 我们如何使用信息；<br />&nbsp;
      &nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;5. 对外提供；<br />&nbsp;
      &nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;6. 您的权利；<br />&nbsp;
      &nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;7. 变更；<br />&nbsp; &nbsp;
      &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;8. 未成年人保护；<br />&nbsp; &nbsp;
      &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;9. 联系我们。
    </p>
    <p style="text-align: left">
      <br />&nbsp; &nbsp; &nbsp;&nbsp;1. 我们收集的信息<br />&nbsp; &nbsp;
      &nbsp;&nbsp;在您使用开始赚服务的过程中，开始赚会按照如下方式收集您在使用服务时主动提供或因为使用服务而产生的信息，用以向您提供服务、优化我们的服务以及保障您的帐号安全：<br />&nbsp;
      &nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;1.1
      当您使用注册功能时，我们会收集您的姓名、手机号码，收集这些信息是为了快速完成开始赚注册，若不提供或不同意收集这类信息，您可能无法正常使用我们的个人信息认证、短信通知等服务。<br />&nbsp;
      &nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;1.2
      当您使用认证功能时，我们会收集您的证件类型、证件号码、省份常驻地、开户行、银行卡号、账户名，收集这些信息是为了完善个人信息，若不提供或不同意收集这类信息，您可能无法正常使用我们的客户推荐功能及佣金发放服务。<br />&nbsp;
      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 1.3
      当您使用证件上传功能时，我们会收集您的证件照图片，收集这些信息是由于开始赚所发放的佣金统一由公司按税法规定预缴税款，在缴纳税款时需收集兼职销售员个人证件照图片，若不提供或不同意收集这类信息，您推荐客户成交后所获得的佣金无法正常发放。<br />&nbsp;
      &nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;1.4
      当您使用客户推荐功能时，我们会收集您所填写的客户姓名、客户手机、客户身份证号后六位、意向楼盘城市、意向楼盘名称，收集这些信息是为完成客户推荐以及查看客户购房状态，若不提供或不同意收集这类信息，您将无法正常推荐客户。<br />&nbsp;
      &nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;1.5
      当您使用开始赚服务时，为保障您正常使用我们的服务，维护我们服务的正常运行，改进及优化我们的服务体验以及保障您的帐号安全，我们会收集您的操作系统、登陆IP地址、服务日志信息（如您修改个人信息、登录操作）等日志信息，这类信息是为提供服务必须收集的基础信息。<br />&nbsp;
      &nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;1.6
      当您使用开始赚服务时，为改进及优化我们的服务体验，给您提供更精确的看房、购房服务，我们会申请收集您的位置信息，您可自行选择是否授权，且后期可在收集设置中自行打开或关闭该授权。<br />&nbsp;
      &nbsp;
      &nbsp;&nbsp;另外，根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用您的相关个人信息无需征求您的授权同意：<br />&nbsp;
      &nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;1）
      与国家安全、国防安全等国家利益直接相关的；<br />&nbsp; &nbsp;
      &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;2）
      与公共安全、公共卫生、公众知情等重大公共利益直接相关的；<br />&nbsp;
      &nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;3）
      与犯罪侦查、起诉、审判和判决执行等关的；<br />&nbsp; &nbsp;
      &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;4）
      出于维护您或其他个人的生命、财产、重大合法权益但又很难得到本人同意的；<br />&nbsp;
      &nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;5）
      所收集的个人信息是您自行向社会公众的；<br />&nbsp; &nbsp;
      &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;6）
      从合法公开披露的信息中收集个人信息合法的新闻报道、政府信息公开等渠道；<br />&nbsp;
      &nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;7）
      根据您要求签订和履行合同所必需的；<br />&nbsp; &nbsp; &nbsp;&nbsp;&nbsp;
      &nbsp; &nbsp;&nbsp;8）
      用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；<br />&nbsp;
      &nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;9）
      为开展合法的新闻报道所必需的；<br />&nbsp; &nbsp; &nbsp;&nbsp;&nbsp;
      &nbsp; &nbsp;&nbsp;10）
      出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
      <br />&nbsp; &nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;11）
      法律法规规定的其他情形。 <br />&nbsp; &nbsp; &nbsp;&nbsp;&nbsp; &nbsp;
      &nbsp;1.7
      当您使用客户推荐功能时，我们会收集您所填写的客户姓名、客户手机、客户身份证号后六位、意向楼盘城市、意向楼盘名称，收集这些信息是为完成客户推荐以及查看客户购房状态，若不提供或不同意收集这类信息，您将无法正常推荐客户。<br />&nbsp;
      &nbsp;
      &nbsp;&nbsp;请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程、网站公告等方式另行向您说明信息收集的内容、范围和目的，以征得您的同意。<br />&nbsp;
      &nbsp;
      &nbsp;&nbsp;请您注意，目前开始赚不会主动从无锡风水隆公司外的第三方获取您的个人信息。如未来为业务发展需要从第三方间接获取您个人信息，我们会在获取前向您明示您个人信息的来源、类型及使用范围，如开始赚开展业务需进行的个人信息处理活动超出您原本向第三方提供个人信息时的授权同意范围，我们将在处理您的该等个人信息前，向您明示并征得您的同意；此外，我们会严格遵守相关法律法规的规定，不从非法渠道间接获取您的个人信息。<br />&nbsp;
      &nbsp; &nbsp;&nbsp;2. 信息的存储<br />&nbsp; &nbsp; &nbsp;&nbsp;&nbsp;
      &nbsp; &nbsp;&nbsp;2.1信息存储的地点<br />&nbsp; &nbsp; &nbsp;&nbsp;&nbsp;
      &nbsp;我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内。<br />&nbsp;
      &nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;2.2信息存储的期限<br />&nbsp;
      &nbsp; &nbsp;&nbsp;&nbsp; &nbsp;
      &nbsp;&nbsp;一般而言，我们仅为实现目的所必需的期限内保留您的个人信息，当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。<br />&nbsp;
      &nbsp; &nbsp;&nbsp;3. 信息安全<br />&nbsp; &nbsp; &nbsp;&nbsp;&nbsp;
      &nbsp;
      &nbsp;&nbsp;我们努力为用户的信息安全提供保障，以防止信息的丢失、不当使用、未经授权访问或披露。我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。例如，我们会使用加密技术（例如，
      SSL）、匿名化处理等手段来保护您的个人信息。我们通过不断提升的技术手段加强安装在您设备端的软件的安全能力，尽最大努力防止您的个人信息泄露。例如，我们为了安全传输您设备本地完成部分信息加密的工作软件发布前进行恶意代码检测等。我们建立专门的管理制度漏洞流程障信息的安全。例如，我们严格限制人员范围，要求他们遵守保密义务，若发生个人信息泄露等安全事件，应急预案推送通知防止该等安全事件进一步公告等形式告知您。<br />&nbsp;
      &nbsp; &nbsp;&nbsp;4. 我们如何使用信息<br />&nbsp; &nbsp;
      &nbsp;&nbsp;&nbsp; &nbsp;
      &nbsp;&nbsp;我们可能将通过某些功能所收集的信息用于我们的其他服务。例如，我们可能将您在使用我们某一功能或服务时我们收集的信息，在另一功能或服务中用于向您提供特定内容，包括但不限于展示广告（您可以在关于广告页面中了解更多）、对您阅读过的内容进行信息安全类提示、基于特征标签进行间接人群画像并提供更加精准和个性化的服务和内容等。<br />&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息，例如，您使用应用程序的频率、崩溃数据、总体使用情况、性能数据以及应用程序的来源等。我们尽可能不会主动将我们存储在分析软件中的信息与您在应用程序中提供的个人身份信息相结合，若存在信息结合的，请您务必立即通知我们处理。<br />&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;如我们使用您的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用您的个人信息前，再次向您告知并征得您的同意。由于信息处理的复杂性，您充分理解并同意若未及时向您告知并征得您同意的，我们可在使用您上述个人信息后再次向您告知并征得您的同意。<br />&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;5. 对外提供<br />&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;目前，开始赚一些功能会向相关监管机构授权的第三方提供信息用于信息真实性验证或服务提供，对此您予以充分理解并完全同意，如当您使用到某些功能触发开始赚短信发送时，为使您能成功收到相关短信，我们会将您的手机号共享至第三方短信运营商；当您使用身份证扫描功能上传证件照时，为验证您上传证件的有效性，我们会将身份证信息共享至第三方进行验证；当您使用认证功能或修改个人信息时，为验证您所填个人信息的正确性，我们会将您的姓名、手机号、身份证和银行卡号共享至第三方进行校验。我们会对对外提供信息的行为进行风险评估，确认以上第三方机构提供的验证服务合法合规。<br />&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;我们不会对外公开披露其收集的个人信息，如必须公开披露时，我们会向您告知此次公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的同意。随着我们业务的持续发展，我们有可能进行合并、收购、资产转让、破产、清算等，我们将告知您相关情形，按照法律法规及不低于本指引所要求的标准继续保护或要求新的控制者继续保护您的个人信息。<br />&nbsp;
      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      另外，根据相关法律法规及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息无需事先征得个人信息主体的授权同意：
    </p>
    <p style="text-align: left; padding-left: 60px">
      <br />1） 与国家安全、国防安全直接相关的；<br />2）
      与公共安全、公共卫生、重大公共利益直接相关的；<br />3）
      与犯罪侦查、起诉、审判和判决执行等直接相关的；<br />4）
      出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
      <br />5） 个人信息主体自行向社会公众公开的个人信息；<br />6）
      从合法公开披露的信息中收集个人信息的，如合法的靳闻报道、政府信息公开等渠道；<br />7）法律法规规定的其他情形。
    </p>
    <p style="text-align: left; padding-left: 30px">
      <br />6.您的权利<br />在您使用开始赚期间，为了您可以更加便捷地访问、更正、删除您的个人信息，同时保障您撤回对个人信息使用的同意及注销帐号的权利，我们在产品设计中为您提供了相应的操作设置，您可以参考下面的指引进行操作。此外，我们还设置了投诉举报渠道，您的意见将会得到及时的处理。<br />&nbsp;
      &nbsp; &nbsp;6.1访问个人信息 <br />&nbsp; &nbsp; &nbsp;&nbsp; &nbsp;
      &nbsp;6.1.1访问【头像、姓名、手机号、证件类型、证件号、常驻地、身份类型、开户行、银行账号、账户名】等基本信息：
    </p>
    <p style="text-align: left; padding-left: 90px">
      <br />1） 进入开始赚后，点击&ldquo;我的&rdquo;；<br />2）
      点击头像或姓名；点击&ldquo;个人信息&rdquo;；<br />3）
      进行信息查询访问。<br />6.1.2访问【证件类型、证件号、姓名】：<br />1）
      进入开始赚后，点击&ldquo;我的&rdquo;；<br />2）
      点击头像或姓名；点击&ldquo;修改证件&rdquo;；<br />3） 进行信息查询访问。
    </p>
    <p style="text-align: left; padding-left: 60px">
      <br />6.2删除个人信息 <br />&nbsp; &nbsp;
      &nbsp;6.2.1删除【头像、姓名、常驻地、开户行、银行账号、证件类型、证件号、账户名】：<br />&nbsp;
      &nbsp; &nbsp; &nbsp;1） 进入开始赚后，点击&ldquo;我的&rdquo;；<br />&nbsp;
      &nbsp; &nbsp; &nbsp;2） 点击头像或姓名；点击&ldquo;个人信息&rdquo;；<br />&nbsp;
      &nbsp; &nbsp; &nbsp;3） 删除信息。<br />&nbsp; &nbsp;
      6.2.2删除【姓名、证件类型、证件号】：<br />&nbsp; &nbsp; &nbsp; &nbsp;1）
      进入开始赚后，点击&ldquo;我的&rdquo;；<br />&nbsp; &nbsp; &nbsp; &nbsp;2）
      点击头像或姓名；点击&ldquo;修改证件&rdquo;；<br />&nbsp; &nbsp; &nbsp;
      &nbsp;3） 删除信息。<br />&nbsp; &nbsp;6.3更正个人信息<br />&nbsp; &nbsp;
      &nbsp;6.3.1更改【头像、姓名、证件类型、证件号、常驻地、开户行、银行账号、账户名】：<br />&nbsp;
      &nbsp; &nbsp; &nbsp;1） 进入开始赚后，点击&ldquo;我的&rdquo;；<br />&nbsp;
      &nbsp; &nbsp; &nbsp;2） 点击头像或姓名；点击&ldquo;个人信息&rdquo;；<br />&nbsp;
      &nbsp; &nbsp; &nbsp;3） 更改信息。<br />&nbsp;6.4注销帐号<br />&nbsp;
      &nbsp; 6.4.1注销开始赚帐号：<br />&nbsp; &nbsp; &nbsp; &nbsp;1）
      进入开始赚后，点击&ldquo;我的&rdquo;；<br />&nbsp; &nbsp; &nbsp; &nbsp;2）
      点击&ldquo;头像或姓名&rdquo;；<br />&nbsp; &nbsp; &nbsp; &nbsp;3）
      点击&ldquo;个人信息&rdquo;；<br />&nbsp; &nbsp; &nbsp; &nbsp;4）
      点击&ldquo;注销帐号&rdquo;注：当您注销帐号后，我们将删除或匿名化处理您的个人信息。
    </p>
    <p style="padding-left: 60px">
      7. 变更<br />在相关法律法规发生变化或我们服务发生变动等情形下，我们如需对本政策内容做出修改，将会在您登陆时以推送通知、弹窗等形式向您提示变更后的条款。您如不同意新的修改内容，请及时与我们联系或立即停止使用本政策约定的服务，如您选择继续使用相关服务，则视为您完全同意并接受新的修改内容。如客观情况及经营方针变化导致我们需中断或停止相关服务的，我们将及时进行通知，请您对此表示理解和认同。<br />8.
      未成年人保护<br />我们非常重视对未成年人个人信息的保护。根据相关法律法规的规定，若您是18周岁以下的未成年人，在使用开始赚服务前，应事先取得您的家长或法定监护人的书面同意。若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过第9节中的联系方式与我们联系。<br />9.
      联系我们
    </p>
    <p style="padding-left: 30px">
      &nbsp; &nbsp; &nbsp;
      &nbsp;当您有其他的投诉、建议、未成年人个人信息相关问题时，您也可以将问题发送至
      <span style="color: #339966">sz.ksz@hkfsl.com</span>。<br />&nbsp; &nbsp;
      &nbsp;
      &nbsp;我们将尽快审核所涉问题，并在成功验证您的用户身份后在15天予以回复。
    </p> -->
    <div v-html="content"></div>
  </div>
</template>
<script>
import { privacyList, privacyGetContent } from '@/api/privacyPolicy.js';
export default {
  data() {
    return {
      ruleList: [],
      content: '',
    };
  },
  mounted() {
    this.getPrivacyList();
  },
  methods: {
    // 获取隐私列表
    async getPrivacyList() {
      let res = await privacyList(1);
      if (res.code != 200) return;
      // console.log('res', res);
      let ruleList = res.data.dataList;
      let matchList = ruleList.filter((item) => {
        return item.name.indexOf('隐私') > -1;
      });
      this.getPrivacyGetContent(matchList[0] && matchList[0].id);
    },
    // 获取隐私内容
    async getPrivacyGetContent(id) {
      let res = await privacyGetContent(id);
      if (res.code != 200) return;
      // console.log('res', res);
      this.content = res.data.content;
    },
  },
};
</script>
